import React, { useState } from 'react'
import { useDarkModeStore } from '../../../../../../store/useDarkModeStore'
import { useLanguageStore } from '../../../../../../store/useLanguageStore';
import { formatNumber, handleFocus } from '../../../../../../common/GlobalFunctions';
import { darkModeBackgroud, darkModeBackgroudInputs } from '../../../../../../utils/constants';
import { PurchaseOrderInterface } from '../../../../../../models/ProcurementModule/PurchateOrder/PurchaseOrder';

interface TotalPurchaseLineProps {
    disabled: boolean;
    form: PurchaseOrderInterface;
    totalPurchaseOrderLines: number;
    setForm: React.Dispatch<React.SetStateAction<PurchaseOrderInterface>>;
}

export const TotalPurchaseLine: React.FC<TotalPurchaseLineProps> = ({ totalPurchaseOrderLines, form, disabled, setForm }) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();

    const [error, setError] = useState<string>('');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const discount = parseFloat(e.target.value);

        if (discount > totalPurchaseOrderLines) {
            setError(`${language['DiscountMessageExceed']} ${totalPurchaseOrderLines} €`);
        } else if (discount < 0) {
            setError(language['DiscountGreaterThan0']);
        } else {
            setError('');
        }

        setForm({ ...form, discount });
    };

    const total = formatNumber(totalPurchaseOrderLines - (form.discount ? form.discount : 0));

    return (
        <div
            className='d-flex align-items-center mt-4 ps-3'
            style={{ background: darkMode ? darkModeBackgroudInputs : 'initial' }}
        >
            <table className={`table ${darkMode && 'table-dark'}`}>
                <tbody>
                    <tr>
                        <td
                            className='fw-bold text-nowrap'
                            style={{
                                border: 'none',
                                fontSize: 14,
                                color: darkMode ? 'white' : '#6c757d',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                marginRight: '5px',
                                verticalAlign: 'middle',
                                height: 40,
                            }}
                        >
                            {language['SubTotal'] ?? 'SubTotal'}:
                        </td>
                        <td
                            className='fw-bold text-end'
                            style={{
                                border: 'none',
                                fontSize: 14,
                                color: darkMode ? 'white' : '#6c757d',
                                padding: '2px 0px',
                            }}
                        >
                            <div className='d-flex align-items-center justify-content-end gap-2 position-relative'>
                                <div className="input-group" style={{ width: 200 }}>
                                    <input
                                        value={totalPurchaseOrderLines ? formatNumber(totalPurchaseOrderLines) : `0.00`}
                                        type="text"
                                        className='form form-control'
                                        style={{
                                            textAlign: 'right',
                                            color: darkMode ? 'white' : 'initial',
                                            background: darkMode ? darkModeBackgroud : '#FBFCFE',
                                        }}
                                        disabled={true}
                                        onChange={handleChange}
                                    />
                                    <span className="input-group-text">€</span>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td
                            className='fw-bold text-end'
                            style={{
                                border: 'none',
                                fontSize: 14,
                                color: darkMode ? 'white' : '#6c757d',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                marginRight: '5px',
                                verticalAlign: 'middle',
                                height: 40,
                            }}
                        >
                            {language['Discount'] ?? 'Discount'}:
                        </td>
                        <td
                            className='fw-bold p-0'
                            style={{
                                border: 'none',
                                fontSize: 14,
                                color: darkMode ? 'white' : '#6c757d'
                            }}
                        >
                            <div className='d-flex align-items-center justify-content-end gap-2 position-relative'>
                                <div className="input-group" style={{ width: 200 }}>
                                    <input
                                        value={form.discount}
                                        type="number"
                                        className='form form-control'
                                        style={{
                                            textAlign: 'right',
                                            color: darkMode ? 'white' : 'initial',
                                            background: darkMode ? darkModeBackgroud : '#FBFCFE',
                                        }}
                                        disabled={disabled}
                                        onChange={handleChange}
                                        onFocus={handleFocus}
                                        onBlur={handleFocus}
                                    />
                                    <span className="input-group-text">€</span>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td
                            className='fw-bold'
                            style={{
                                border: 'none',
                                fontSize: 14,
                                color: darkMode ? 'white' : '#6c757d',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                marginRight: '5px',
                                verticalAlign: 'middle',
                                height: 40,
                            }}
                        >
                            <span>{language['Total'] ?? 'Total'}:</span>
                        </td>
                        <td
                            className='fw-bold'
                            style={{
                                border: 'none',
                                fontSize: 14,
                                color: darkMode ? 'white' : '#6c757d',
                                padding: '2px 0px'
                            }}
                        >
                            <div className='d-flex align-items-center justify-content-end gap-2 position-relative'>
                                <div className="input-group" style={{ width: 200 }}>
                                    <input
                                        value={total}
                                        type="text"
                                        className='form form-control'
                                        style={{
                                            textAlign: 'right',
                                            color: darkMode ? 'white' : 'initial',
                                            background: darkMode ? darkModeBackgroud : '#FBFCFE',
                                        }}
                                        disabled={true}
                                        onChange={handleChange}
                                    />
                                    <span className="input-group-text">€</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2} className='pt-0 pb-0' style={{ border: 'none' }}>
                            {error
                                && <div className='invalid-feedback-danger'>
                                    {error}
                                </div>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default TotalPurchaseLine;
